import React, { Component } from 'react';
import { Modal, Checkbox, message } from 'antd';
import CompareVersion from './CompareVersion';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';

const CheckboxGroup = Checkbox.Group;

class SelectCompareVersion extends Component {
    state = {
        visible: false,
        version: undefined,
        checkedValues: [],
    }

    show = () => {
        this.setState({
            visible: true,
            version: undefined,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            checkedValues: [],
        });
    }

    submit = () => {
        const { checkedValues } = this.state;
        if (checkedValues.length <= 1) {
            message.warning('请选择至少2个版本进行对比!');
            return;
        }
        this.hide();
        this.compreVersionRef.show(checkedValues);
    }

    handleChange = (checkedValues) => {
        this.setState({ checkedValues });
    }

    render() {
        const { visible, checkedValues } = this.state;
        const plainOptions = [
            { label: 'V1', value: 'V1' },
            { label: 'V2', value: 'V2' },
            { label: 'V3', value: 'V3' },
        ];
        return (
            <Modal
                title="选择对比版本"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
            >
                <div style={{ padding: '0px 10px 10px' }}>
                    <div style={{ marginBottom: 10, padding: 10, background: '#f1f1f1' }}>请选择需要对比的报价单版本：</div>
                    <CheckboxGroup options={plainOptions} value={checkedValues} onChange={this.handleChange} />
                </div>
                <CompareVersion ref={el => this.compreVersionRef = el} />
            </Modal>
        );
    }
}

export default SelectCompareVersion;


// WEBPACK FOOTER //
// ./src/components/quotation/Sidebar/Components/SelectCompareVersion.js